<script>
import Layout from "../../../../layouts/main";
import viewOutletOpsTicket from "./viewOutletOpsTicket";
import Edit from "./edit";
import ChangeTat from "./changeTat.vue";
import axios from "axios";
import { TicketsPath } from "@/path";
import ViewSupplyTicket from "./viewSupplyTicket.vue";
import viewRetraingingTickets from "./viewRetrainingTickets.vue";
import Swal from "sweetalert2";
import TransferTicket from "./transferTicket.vue";
import moment from "moment";
import ViewCommonTickets from "./viewCommonTickets.vue";

export default {
  components: {
    Layout,
    Edit,
    viewOutletOpsTicket,
    ViewSupplyTicket,
    TransferTicket,
    viewRetraingingTickets,
    ViewCommonTickets,
    ChangeTat,
  },
  data() {
    return {
      fields: [
        "ticket_no",
        "ticket_id",
        "rp_name",
        "assignee",
        "tat",
        "action",
      ],
      tickets: [],
      selected: null,
      current_page: 1,
      base_url: process.env.VUE_APP_API_BACKEND_URL,
      options: [
        { value: null, text: "Select Assignee" },
        { value: "AM1", text: "AM1" },
        { value: "AM2", text: "AM2" },
      ],
      assigneeOptions: [
        { value: null, text: "Assignee1" },
        { value: "Assignee2", text: "Assignee2" },
      ],
      categoryOptions: [
        { value: null, text: "Supply" },
        { value: "Payout", text: "Payout" },
        { value: "Pos", text: "Pos" },
        { value: "Signage", text: "Signage" },
        { value: "Outlet Ops", text: "Outlet Ops" },
      ],
      priorityOptions: [
        {
          value: "low",
          text: "Normal",
        },
        {
          value: "medium",
          text: "Medium",
        },
        {
          value: "high",
          text: "High",
        },
      ],
      statusOptions: [
        {
          value: "open",
          text: "Open",
        },
        {
          value: "in_progress",
          text: "In Progress",
        },
        {
          value: "resolved",
          text: "Resolved",
        },
      ],
      search: null,
      selectedStatus: "open",
      items: [
        {
          ticket_no: 1,
          ticket_id: 345834,
          rp_name: "happy kitchen",
          assignee: "AM2",
          tat: "08/06/2024 20:24",
        },
      ],
      ticketDetails: {},
      ticket: null,
      openTickets: 0,
      inProgressTickets: 0,
      resolvedTickets: 0,
    };
  },
  mounted() {
    this.getTickets();
    this.getNoOfTickets();
  },
  methods: {
    editTicket() {
      this.$bvModal.show("bv-edit");
    },
    viewTicket(v) {
      this.ticketDetails = v;
      if (v.category == "outlet_ops") {
        this.$bvModal.show("bv-outlet-ops-view");
      } else if (v.category == "supply") {
        this.$bvModal.show("bv-supply-view");
      } else if (v.category == "retraining") {
        this.$bvModal.show("bv-retraining-view");
      } else {
        this.$bvModal.show("bv-common-view");
      }
    },
    transferTicket(v) {
      this.ticketDetails = v;
      this.$bvModal.show("bv-transfer-ticket");
    },
    formatDate(v) {
      return moment(v).format("DD-MM-YYYY hh:mm A");
    },
    async getTickets() {
      try {
        let res = await axios.get(this.base_url + TicketsPath.GET_TICKETS, {
          params: {
            page: this.current_page,
            search: this.search,
            status: this.selectedStatus,
          },
        });
        if (res.data.status) {
          this.tickets = res.data.data;
          if (this.selectedStatus == "open") {
            this.openTickets = res.data.data.total;
          } else if (this.selectedStatus == "in_progress") {
            this.inProgressTickets = res.data.data.total;
          } else {
            this.resolvedTickets = res.data.data.total;
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
    async getNoOfTickets() {
      try {
        const fetchTickets = async (status) => {
          const response = await axios.get(
            this.base_url + TicketsPath.GET_TICKETS,
            {
              params: {
                page: this.current_page,
                search: this.search,
                status: status,
              },
            }
          );
          if (response.data.status) {
            return response.data.data.total;
          }
          return 0;
        };

        const [inProgressTickets, resolvedTickets] = await Promise.all([
          fetchTickets("in_progress"),
          fetchTickets("resolved"),
        ]);

        this.inProgressTickets = inProgressTickets;
        this.resolvedTickets = resolvedTickets;
      } catch (error) {
        console.error("Error fetching tickets:", error);
      }
    },
    async changePriority(v, $event) {
      try {
        let res = await axios.post(
          this.base_url + TicketsPath.UPDATE_TICKET_PRIORITY,
          {
            ticket_id: v.id,
            priority: $event,
          }
        );
        if (res.data.status) {
          Swal.fire("Success", "", "success");
        }
      } catch (error) {
        console.log(error);
      }
    },
    navigateToRaiseTicket() {
      this.$router.push("/raise_ticket");
    },
    async changeStatus(v, $event) {
      try {
        const { value: comment } = await Swal.fire({
          title: "Please Enter Your Comment",
          input: "textarea",
          inputValue: "",
          showCancelButton: true,
          inputAttributes: {
            "aria-label": "Comment",
            style:
              "height: 100px; border: 2px solid #3498db; border-radius: 4px; padding: 10px",
          },
          inputValidator: (value) => {
            if (!value) {
              return "Cannot be empty";
            }
          },
        });
        let res = await axios.post(
          this.base_url + TicketsPath.UPDATE_TICKET_STATUS,
          {
            ticket_id: v.id,
            status: $event,
            comment: comment,
          }
        );
        if (res.data.status) {
          this.getTickets();
          Swal.fire("Success", "", "success");
        }
      } catch (error) {
        console.log(error);
      }
    },
    openChangeTat(t) {
      this.ticket = t;
      this.$bvModal.show("bv-change-tat");
    },
    getTime(time) {
      const givenTime = new Date(time);

      const currentTime = new Date();

      const timeDifference = currentTime - givenTime;

      const hoursDifference = timeDifference / (1000 * 60 * 60);

      return hoursDifference;
    },
    calculateTimeDifference(createdAt, resolvedAt) {
      const createdDate = new Date(createdAt);
      const resolvedDate = new Date(resolvedAt);

      let diffMs = resolvedDate - createdDate; // Difference in milliseconds
      let days = Math.floor(diffMs / (1000 * 60 * 60 * 24));
      diffMs %= 1000 * 60 * 60 * 24;

      let hours = Math.floor(diffMs / (1000 * 60 * 60));
      diffMs %= 1000 * 60 * 60;

      let minutes = Math.floor(diffMs / (1000 * 60));

      return days > 0
        ? `${days}d ${hours}h ${minutes}m`
        : `${hours}h ${minutes}m`;
    },
    getStatusColor(createdAt, resolvedAt) {
      const createdDate = new Date(createdAt);
      const resolvedDate = new Date(resolvedAt);

      let diffMs = resolvedDate - createdDate;
      let days = Math.floor(diffMs / (1000 * 60 * 60 * 24));

      if (days < 1) return "lightgreen";
      if (days < 2) return "lightcoral";
      return "#fa5757";
    },
  },
  watch: {
    current_page() {
      this.getTickets();
    },
    search() {
      this.getTickets();
    },
    selectedStatus() {
      this.getTickets();
    },
  },
};
</script>
<template>
  <Layout>
    <b-row>
      <b-col>
        <h2 style="color: teal; margin-bottom: 30px">Support System</h2>
      </b-col>
    </b-row>
    <div>
      <b-modal id="bv-change-tat" size="md" hide-footer>
        <ChangeTat :ticket="ticket"></ChangeTat>
      </b-modal>
      <b-modal id="bv-outlet-ops-view" size="lg" hide-footer>
        <viewOutletOpsTicket
          :ticket_details="ticketDetails"
        ></viewOutletOpsTicket>
      </b-modal>
      <b-modal id="bv-supply-view" size="xl" hide-footer>
        <ViewSupplyTicket :ticket="ticketDetails"></ViewSupplyTicket>
      </b-modal>
      <b-modal id="bv-transfer-ticket" size="lg" hide-footer>
        <TransferTicket
          :ticket="ticketDetails"
          @close="
            () => this.getTickets()(this.$bvModal.hide('bv-transfer-ticket'))
          "
        ></TransferTicket>
      </b-modal>
      <b-modal id="bv-retraining-view" size="lg" hide-footer>
        <viewRetraingingTickets
          :ticket="ticketDetails"
        ></viewRetraingingTickets>
      </b-modal>
      <b-modal id="bv-common-view" size="xl" hide-footer>
        <ViewCommonTickets :ticket="ticketDetails"></ViewCommonTickets>
      </b-modal>
      <b-modal id="bv-edit" size="lg" hide-footer>
        <Edit></Edit>
      </b-modal>
      <b-button
        v-if="
          $store.state.authfack.user.roles.filter(
            (f) => f.name == 'RestaurantPartner'
          ).length > 0
        "
        variant="primary"
        class="mb-4"
        @click="navigateToRaiseTicket"
      >
        Raise Ticket
      </b-button>
      <!-- <b-row>
        <b-col sm="4">
          <b-input v-model="search"></b-input>
        </b-col>
      </b-row> -->
      <b-card-text>
        <b-tabs>
          <b-tab
            v-for="(s, si) in statusOptions"
            :key="si"
            @click="
              () => {
                selectedStatus = s.value;
              }
            "
          >
            <template #title>
              {{ s.text }}
              <span style="color: #17a2b8; font-weight: 900; font-size: medium">
                ({{
                  s.text === "Open"
                    ? openTickets
                    : s.text === "In Progress"
                    ? inProgressTickets
                    : resolvedTickets
                }})
              </span>
            </template>
          </b-tab>
        </b-tabs>
        <div
          style="
            background-color: rgba(243, 246, 251, 0.3);
            margin-bottom: 15px;
            margin-top: 10px;
            border: 1px solid rgb(240, 240, 240);
            border-radius: 5px;
          "
          v-for="(t, ti) in tickets.data"
          :key="ti"
        >
          <div style="padding-inline: 15px; padding-block: 10px">
            <div
              style="
                display: flex;
                justify-content: space-between;
                align-items: center;
              "
            >
              <div style="display: flex; gap: 10px">
                <h6
                  style="
                    text-transform: capitalize;
                    margin-bottom: 0px !important;
                  "
                  class="category-heading"
                >
                  {{ t.category.split("_").join(" ") }}
                </h6>
                <h6
                  v-if="t.extra_details.issue"
                  style="margin-bottom: 0px !important"
                >
                  -
                </h6>
                <h6
                  v-if="t.extra_details.issue"
                  style="
                    text-transform: capitalize;
                    margin-bottom: 0px !important;
                  "
                  class="category-heading"
                >
                  {{ t.extra_details.issue.split("_").join(" ") }}
                </h6>
                <p
                  v-if="
                    t.extra_details.issue == 'wrong_item' ||
                    t.extra_details.issue == 'missing_item/qty' ||
                    t.extra_details.issue == 'damaged_item/pkg' ||
                    t.extra_details.issue == 'excess_qty'
                  "
                >
                  Order #:{{ t.extra_details.order }}
                </p>
              </div>
              <div class="d-block d-sm-none">
                <b-button
                  @click="transferTicket(t)"
                  v-if="
                    $store.state.authfack.user.roles.filter(
                      (f) => f.name != 'RestaurantPartner'
                    ).length > 0
                  "
                  size="sm"
                  >Transfer To</b-button
                >
                <b-button size="sm" class="ml-1 ml-sm-4" @click="viewTicket(t)">
                  <i class="fa fa-eye"></i>
                </b-button>
              </div>
              <div class="d-none d-sm-block">
                <b-button
                  @click="transferTicket(t)"
                  v-if="
                    $store.state.authfack.user.roles.filter(
                      (f) => f.name != 'RestaurantPartner'
                    ).length > 0
                  "
                  >Transfer To</b-button
                >
                <b-button class="ml-1 ml-sm-4" @click="viewTicket(t)">
                  <i class="fa fa-eye"></i>
                </b-button>
              </div>
            </div>
            <div class="d-block d-sm-none">
              <p
                v-if="
                  $store.state.authfack.user.roles.filter(
                    (f) => f.name != 'RestaurantPartner'
                  ).length > 0
                "
              >
                RP: {{ t.restaurant.name }}
              </p>
              <p>Ticket Id : {{ t.ticket_id }}</p>
              <p>
                <i class="fa fa-clock mr-1"></i>
                {{ formatDate(t.created_at) }}
              </p>
              <p
                v-if="
                  $store.state.authfack.user.roles.filter(
                    (f) => f.name != 'RestaurantPartner'
                  ).length > 0
                "
              >
                <span
                  v-if="selectedStatus == 'resolved'"
                  style="
                    padding-inline: 5px;
                    background-color: rgba(0, 255, 0, 0.04);
                    color: green;
                  "
                  class="rounded-sm"
                  >Resolved</span
                >
                <span
                  v-else
                  :style="{
                    paddingInline: '5px',
                    backgroundColor:
                      getTime(t.created_at) > 48
                        ? 'rgba(255, 0, 0, 0.04)'
                        : getTime(t.created_at) > 24
                        ? 'rgba(139, 69, 19, 0.04)'
                        : 'rgba(0, 255, 0, 0.04)',
                    color:
                      getTime(t.created_at) > 48
                        ? 'red'
                        : getTime(t.created_at) > 24
                        ? 'brown'
                        : 'green',
                  }"
                  class="rounded-sm"
                >
                  Tat - {{ formatDate(t.tat) }}
                </span>
              </p>
              <p
                v-if="
                  $store.state.authfack.user.roles.filter(
                    (f) => f.name == 'RestaurantPartner'
                  ).length > 0
                "
              >
                <span
                  v-if="selectedStatus == 'resolved'"
                  style="
                    background-color: rgba(0, 255, 0, 0.04);
                    color: green;
                    padding-inline: 5px;
                  "
                  class="rounded-sm"
                  >Resolved</span
                >
                <span
                  v-else
                  :style="{
                    paddingInline: '5px',
                    backgroundColor:
                      getTime(t.created_at) > 48
                        ? 'rgba(255, 0, 0, 0.04)'
                        : getTime(t.created_at) > 24
                        ? 'rgba(139, 69, 19, 0.04)'
                        : 'rgba(0, 255, 0, 0.04)',
                    color:
                      getTime(t.created_at) > 48
                        ? 'red'
                        : getTime(t.created_at) > 24
                        ? 'brown'
                        : 'green',
                  }"
                  class="rounded-sm"
                >
                  Expected Res time - {{ formatDate(t.tat) }}
                </span>
              </p>
            </div>
            <div
              style="display: flex; gap: 10px; flex-wrap: wrap"
              class="d-none d-sm-flex"
            >
              <p>{{ t.ticket_id }}</p>
              <p
                v-if="
                  $store.state.authfack.user.roles.filter(
                    (f) => f.name != 'RestaurantPartner'
                  ).length > 0
                "
              >
                |
              </p>
              <p
                v-if="
                  $store.state.authfack.user.roles.filter(
                    (f) => f.name != 'RestaurantPartner'
                  ).length > 0
                "
              >
                {{ t.restaurant.name }}
              </p>
              <p>|</p>
              <p>
                <i class="fa fa-clock"></i>
                {{ formatDate(t.created_at) }}
              </p>
              <div style="display: flex; gap: 5px">
                <p
                  v-if="
                    $store.state.authfack.user.roles.filter(
                      (f) => f.name != 'RestaurantPartner'
                    ).length > 0
                  "
                >
                  <span
                    v-if="selectedStatus == 'resolved'"
                    style="
                      padding-inline: 10px;
                      background-color: rgba(0, 255, 0, 0.04);
                      color: green;
                    "
                    class="rounded-sm"
                    >Resolved</span
                  >
                  <span
                    v-else
                    :style="{
                      paddingInline: '10px',
                      backgroundColor:
                        getTime(t.created_at) > 48
                          ? 'rgba(255, 0, 0, 0.04)'
                          : getTime(t.created_at) > 24
                          ? 'rgba(139, 69, 19, 0.04)'
                          : 'rgba(0, 255, 0, 0.04)',
                      color:
                        getTime(t.created_at) > 48
                          ? 'red'
                          : getTime(t.created_at) > 24
                          ? 'brown'
                          : 'green',
                    }"
                    class="rounded-sm"
                  >
                    Tat - {{ formatDate(t.tat) }}
                  </span>
                </p>
                <p
                  v-if="
                    $store.state.authfack.user.roles.filter(
                      (f) => f.name == 'RestaurantPartner'
                    ).length > 0
                  "
                >
                  <span
                    v-if="selectedStatus == 'resolved'"
                    style="
                      padding-inline: 10px;
                      background-color: rgba(0, 255, 0, 0.04);
                      color: green;
                    "
                    class="rounded-sm"
                    >Resolved</span
                  >
                  <span
                    v-else
                    :style="{
                      paddingInline: '10px',
                      backgroundColor:
                        getTime(t.created_at) > 48
                          ? 'rgba(255, 0, 0, 0.04)'
                          : getTime(t.created_at) > 24
                          ? 'rgba(139, 69, 19, 0.04)'
                          : 'rgba(0, 255, 0, 0.04)',
                      color:
                        getTime(t.created_at) > 48
                          ? 'red'
                          : getTime(t.created_at) > 24
                          ? 'brown'
                          : 'green',
                    }"
                    class="rounded-sm"
                  >
                    Expected Resolution time - {{ formatDate(t.tat) }}
                  </span>
                </p>
                <p
                  style="color: rgb(72, 132, 211); cursor: pointer"
                  @click="openChangeTat(t)"
                  v-if="
                    $store.state.authfack.user.roles.filter(
                      (f) => f.name != 'RestaurantPartner'
                    ).length > 0 && selectedStatus != 'resolved'
                  "
                >
                  <i class="fa fa-pen"></i>
                </p>
              </div>
            </div>
          </div>
          <hr style="margin: 0px" />
          <div style="padding-inline: 15px; padding-block: 10px">
            <div
              style="
                display: flex;
                margin-bottom: 0px;
                justify-content: space-between;
                align-items: center;
                flex-wrap: wrap;
              "
            >
              <div
                v-if="
                  $store.state.authfack.user.roles.filter(
                    (f) => f.name != 'RestaurantPartner'
                  ).length > 0
                "
              >
                <p>
                  Assignee :
                  <span style="text-transform: capitalize">
                    {{ t.assignee?.user?.name }}</span
                  >
                </p>
              </div>
              <div
                v-if="
                  $store.state.authfack.user.roles.filter(
                    (f) => f.name != 'RestaurantPartner'
                  ).length > 0
                "
              >
                <b-form-select
                  @change="changePriority(t, $event)"
                  :options="priorityOptions"
                  :value="t.priority"
                  class="size-sm"
                  plain
                ></b-form-select>
              </div>
              <div
                v-if="
                  $store.state.authfack.user.roles.filter(
                    (f) => f.name != 'RestaurantPartner'
                  ).length > 0
                "
              >
                <b-form-select
                  @change="changeStatus(t, $event)"
                  :options="statusOptions"
                  :value="t.status"
                  class="size-sm"
                  plain
                ></b-form-select>
              </div>
              <div
                v-if="
                  $store.state.authfack.user.roles.filter(
                    (f) => f.name == 'RestaurantPartner'
                  ).length > 0
                "
                style="text-transform: capitalize"
              >
                Priority : {{ t.priority }}
              </div>
              <div></div>
            </div>
          </div>
          <hr style="margin: 0px" v-if="selectedStatus != 'open'" />
          <div
            style="padding-inline: 15px; padding-block: 10px"
            v-if="selectedStatus != 'open'"
          >
            <div
              style="
                display: flex;
                gap: 10px;
                flex-wrap: wrap;
                align-items: center;
              "
            >
              <p
                style="
                  padding: 5px;
                  background-color: lightgray;
                  border-radius: 5px;
                  color: black;
                  letter-spacing: 1px;
                "
              >
                Comment: {{ t.comments[t.comments.length - 1]?.comment }}
              </p>
              <p
                :style="{
                  padding: '5px',
                  borderRadius: '5px',
                  color: 'black',
                  backgroundColor: getStatusColor(
                    t.created_at,
                    t.status_updated_at
                  ),
                }"
              >
                Resolved in :
                {{ calculateTimeDifference(t.created_at, t.status_updated_at) }}
              </p>
            </div>
          </div>
        </div>
      </b-card-text>
      <div class="row mb-3">
        <div class="col">
          <div class="dataTables_paginate paging_simple_numbers float-right">
            <ul class="pagination pagination-rounded mb-0">
              <b-pagination
                :key="tickets.key"
                v-model="current_page"
                :total-rows="tickets.total"
                :per-page="tickets.per_page"
                class="dataTables_paginate"
              ></b-pagination>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
<style>
.tab-pane {
  padding: 0px !important;
}
.dataTables_paginate {
  display: flex !important;
}

@media (max-width: 598px) {
  .category-heading {
    font-size: 14px !important;
  }
}
</style>
